import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

// {
//   "type": "G",
//   "title": "주어진 한글 뜻을 보고 빈칸에 알맞은 영단어를 쓰세요.",
//   "questions": [
//     {
//       "question": "Something that is inapplicable to what you are talking about is not relevant or appropriate to it.",
//       "answer": "inapplicable"
//     }
//   ]
// }

function GTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList G:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                display: 'grid',
                gridTemplateColumns: '1.2fr 8.8fr',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '5px',
                fontFamily: "'Pretendard', Arial, sans-serif",
                width: '100%',
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  minWidth: '10px',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                {startNo + idx}.
              </div>
              {(tab === PAPER_TABS.TEST_PAPER ||
                tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                <div style={{ fontFamily: "'Pretendard', Arial, sans-serif" }}>
                  <div
                    style={{
                      fontFamily: "'Pretendard', Arial, sans-serif",
                      marginBottom: '5px',
                    }}
                  >
                    {strParse(voca.question)}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                      fontFamily: "'Pretendard', Arial, sans-serif",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: '1px solid #000',
                        minWidth: '100px',
                        minHeight: '18px',
                        display: 'flex',
                        fontFamily: "'Pretendard', Arial, sans-serif",
                        justifyContent: 'center',
                        alignItems: 'flex-end',
                        paddingBottom: '5px',
                      }}
                    >
                      {tab === PAPER_TABS.TEST_PAPER && ''}
                      {tab === PAPER_TABS.TEST_PAPER &&
                        config?.vocaFirstWordShow && (
                          <div style={{ width: '100%', textAlign: 'left' }}>
                            {voca?.answer[0]}
                          </div>
                        )}
                      {tab === PAPER_TABS.ANSWER_TEST_PAPER && voca.answer}
                    </div>
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {tab === PAPER_TABS.ANSWER && voca?.answer}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

GTypeTestRow.propTypes = {
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
};

export default GTypeTestRow;
